import { forwardRef, Icon, IconProps } from '@chakra-ui/react';
import { useIconId } from '../utils';

const BitbucketShadedWhite = forwardRef<IconProps, 'svg'>((props, ref) => {
  const iconPrefix = useIconId();

  return (
    <Icon ref={ref} viewBox="0 0 24 24" {...props}>
      <path
        d="M21.1247 9.02767H15.1303L14.1313 14.9222H9.96851L5.07312 20.75C5.07312 20.75 5.30622 20.9499 5.63925 20.9499H18.6937C18.9934 20.9499 19.2599 20.7168 19.3264 20.417L21.1247 9.02767Z"
        fill={`url(#${iconPrefix}__a)`}
      />
      <path
        d="M2.64201 3C2.24238 3 1.94269 3.36633 2.00929 3.73265L4.70678 20.2506C4.74008 20.4504 4.84 20.6503 5.00651 20.7834C5.00651 20.7834 5.23961 20.9833 5.57264 20.9833L10.6346 14.9223H9.93526L8.83626 9.02776L15.1303 9.02767H21.1247L21.9907 3.73265C22.0574 3.33303 21.7576 3 21.3579 3H2.64201Z"
        fill="white"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${iconPrefix}__a`}
          x1={22.9852}
          x2={9.97413}
          y1={6.96468}
          y2={14.2395}
        >
          <stop offset={0.0718327} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
      </defs>
    </Icon>
  );
});

export default BitbucketShadedWhite;
